import { isNil } from 'lodash';
import {
  AssemblyJourneys,
  CodJourney,
  SectionJourney,
} from 'src/constants/assemblyJourneys';
import {
  GlobalComponentsScreenInterface,
  IScreen,
  ISection,
  SectionTypes,
} from 'src/interfaces';

import { lang } from './language';
import {
  isCurrentScreenWithCOD,
  isCurrentScreenWithCODThankYou,
  isCurrentScreenWithDYR,
  isCurrentScreenWithDYS,
} from './layout-builder-helper';

export const getSectionName = (
  section: ISection,
  screen: IScreen,
  sectionTypes: SectionTypes[] | undefined,
  activeAssemblyJourney: AssemblyJourneys | undefined,
  globalComponentsScreen?: GlobalComponentsScreenInterface,
) => {
  if (
    sectionTypes?.includes(SectionTypes.DYR) &&
    activeAssemblyJourney !== SectionJourney.SECTION_ROTATION &&
    (section.top_offset === 1320 || section.top_offset === 1480) &&
    section.name === '3x1 Block' &&
    isCurrentScreenWithDYR(
      screen.channel_screen_sequence,
      globalComponentsScreen,
    )
  ) {
    return lang.editLayoutsSidebar.dynamicArea;
  }
  const isScreenWithDYS = globalComponentsScreen
    ? isCurrentScreenWithDYS(
        screen.channel_screen_sequence,
        globalComponentsScreen,
      )
    : screen.channel_screen_sequence === 2;
  if (
    sectionTypes?.includes(SectionTypes.DYS) &&
    section.name === '2x3 Block' &&
    activeAssemblyJourney !== SectionJourney.SECTION_ROTATION &&
    !isNil(section.config?.events) &&
    isScreenWithDYS
  ) {
    return lang.editLayoutsSidebar.combo;
  }
  const isScreenWithCOD = globalComponentsScreen
    ? isCurrentScreenWithCOD(
        screen.channel_screen_sequence,
        globalComponentsScreen,
      )
    : screen.channel_screen_sequence === 2;
  if (
    sectionTypes?.includes(SectionTypes.DYP) &&
    section.name === '1x1 Block' &&
    activeAssemblyJourney !== SectionJourney.SECTION_ROTATION &&
    (section.top_offset === 0 || section.top_offset === 160) &&
    !isNil(section.config?.events) &&
    isScreenWithCOD
  ) {
    return lang.editLayoutsSidebar.promoOne;
  }
  if (
    sectionTypes?.includes(SectionTypes.DYP) &&
    section.name === '1x1 Block' &&
    activeAssemblyJourney !== SectionJourney.SECTION_ROTATION &&
    (section.top_offset === 440 || section.top_offset === 600) &&
    !isNil(section.config?.events) &&
    isScreenWithCOD
  ) {
    return lang.editLayoutsSidebar.promoTwo;
  }
  if (
    sectionTypes?.includes(SectionTypes.DYS) &&
    section.name === '2x1 Block' &&
    activeAssemblyJourney !== SectionJourney.SECTION_ROTATION &&
    !isNil(section.config?.events) &&
    isScreenWithDYS
  ) {
    return lang.editLayoutsSidebar.codTriggeredArea;
  }
  if (
    sectionTypes?.includes(SectionTypes.COD) &&
    section.name === '1x2 Block' &&
    activeAssemblyJourney !== SectionJourney.SECTION_ROTATION &&
    !isNil(section.config?.events) &&
    isScreenWithCOD
  ) {
    if (activeAssemblyJourney === CodJourney.PURCHASE_IS_CONFIRMED) {
      return lang.editLayoutsSidebar.confirmation;
    }

    return lang.editLayoutsSidebar.cod;
  }
  if (
    sectionTypes?.includes(SectionTypes.THANK_YOU) &&
    activeAssemblyJourney !== SectionJourney.SECTION_ROTATION &&
    activeAssemblyJourney === CodJourney.PURCHASE_IS_CONFIRMED &&
    !isNil(section.config?.events) &&
    isCurrentScreenWithCODThankYou(
      screen.channel_screen_sequence,
      globalComponentsScreen,
    )
  ) {
    return lang.editLayoutsSidebar.thankYou;
  }
  if (section.height === 160 || section.height === 72) {
    return `${lang.disclaimer}`;
  }
};
